var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"info-list-block"},[_c('div',{staticClass:"label"},[_vm._v(_vm._s(item.label))]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(item.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }